import { classNames } from "primereact/utils";
import { IconType } from "../../../icons/Icon";
import { IconButton } from "../iconButton/IconButton";
import styles from "./SwipeableActionButton.module.scss";

interface ISwipeableActionButtonProps {
  className?: string;
  icon: IconType;
  disabled?: boolean;
  onClick?: () => void;
}

export const SwipeableActionButton = ({
  className,
  icon,
  disabled,
  onClick = () => {},
}: ISwipeableActionButtonProps) => {
  return (
    <IconButton
      className={classNames(styles.root, className)}
      iconType={icon}
      disabled={disabled}
      iconHeight="40%"
      onClick={onClick}
    />
  );
};
